import { render, staticRenderFns } from "./editSeminar.vue?vue&type=template&id=1d443a4a&"
import script from "./editSeminar.vue?vue&type=script&lang=js&"
export * from "./editSeminar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports